<template>
    <el-dialog
        :title="expend && expend.id ? '修改支出' : '新增支出'"
        :visible.sync="showDialog"
        width="500px"
        @closed="refeshRule"
    >
        <el-form ref="addForm" :model="expend" label-width="80px" :rules="rules">
            <el-form-item label="所属店铺" prop="shopId">
                <el-select v-model="expend.shopId" placeholder="请选择所属店铺">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="支出类型" prop="typeId">
                <el-select v-model="expend.typeId" placeholder="请选择支出类型">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="支出日期" prop="expendTime">
                <el-date-picker
                    type="date"
                    placeholder="选择计划开始日期"
                    v-model="expend.expendTime"
                    style="width: 100%"
                ></el-date-picker>
            </el-form-item>

            <el-form-item label="支出金额" prop="cost_2">
                <el-input-number v-model="expend.cost_2" :min="0" :precision="2" :controls="false"></el-input-number>
            </el-form-item>

            <el-form-item label="关联订单" prop="orderId">
                <el-input v-model="expend.orderId"></el-input>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
                <el-input v-model="expend.remark" type="textarea"></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" class="op-button" @click="postAdd">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        show: { type: Boolean, default: false },
        afterAdd: { type: Function, default: null },
    },
    data() {
        return {
            showDialog: false,
            records: null,
            shops: null,
            types: null,
            expend: {},
            rules: {
                shopId: [
                    { required: true, message: "请关联店铺", trigger: "blur" },
                ],

                typeId: [
                    {
                        required: true,
                        message: "请选择支出类型",
                        trigger: "blur",
                    },
                ],

                expendTime: [
                    {
                        required: true,
                        message: "请输入支出时间",
                        trigger: "blur",
                    },
                ],

                cost_: [
                    {
                        required: true,
                        message: "请输入支出金额",
                        trigger: "blur",
                    },
                ],
                orderId: [
                    {
                        min: 0,
                        max: 40,
                        message: "长度在 0 到 40 个字符",
                        trigger: "blur",
                    },
                ],
                remark: [
                    {
                        min: 0,
                        max: 64,
                        message: "长度在 0 到 64 个字符",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        getShop() {
            let _this = this;

            _this.$http.post(
                ["taobao/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                "none"
            );
        },

        getType() {
            let _this = this;

            _this.$http.post(
                ["taobao/expend/type/all"],
                [
                    function (data) {
                        _this.types = data;
                    },
                ],
                "none"
            );
        },
        postAdd() {
            this.$refs["addForm"].validate().then(this.doAdd);
        },
        doAdd() {
            let _this = this;

            _this.expend.cost = _this.expend.cost_2 * 100;

            _this.$http.post(
                ["taobao/expend/save", _this.expend],
                [
                    function (data) {
                        _this.showDialog = false;
                        _this.expend = {};
                        _this.$emit("afterAdd", data);
                    },
                ],
                ".op-button"
            );
        },
        refeshRule() {
            this.expend = {};
            this.$refs["addForm"].resetFields();
            this.$emit("update:show", false);
        },
    },
    mounted() {},
    watch: {
        show(val) {
            if (val) {
                this.getShop();
                this.getType();
            }
            this.showDialog = val;
            this.expend = {};
        },
    },
};
</script>

<style lang="scss">
</style>